import PageLoader from "components/general/PageLoader";
import { useLocalSearchParams } from "expo-router";
import React from "react";
import { useGetGlAccountByIdQuery, usePutGlAccountByIdMutation, useDeleteGlAccountByIdDeletestockcodeMutation, usePostGlAccountByIdAddstockcodeMutation } from "store/abcoApi";
import { Box } from "components/ui";
import StockCollectionDetailScreen from "screens/StockCollectionDetailScreen";

export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	const { id } = useLocalSearchParams<{ id: string }>();
	const [searchFilterTerm, setSearchFilterTerm] = React.useState("");
	const { data: glAccount, isLoading, isFetching } = useGetGlAccountByIdQuery({ id: Number(id), pageNumber  });
	const [putGlAccount, { isLoading: isSaving }] = usePutGlAccountByIdMutation();
	const [ deleteStockcode ] = useDeleteGlAccountByIdDeletestockcodeMutation();

	const [addStockcode] = usePostGlAccountByIdAddstockcodeMutation();


	if (isLoading || glAccount == null) {
		return (
			<Box minHeight={150}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box>
			<StockCollectionDetailScreen
				catalogue={glAccount}
				removeStockcode={deleteStockcode}
				addStockcode={addStockcode}
				setPageNumber={setPageNumber} 
				setSearchFilterTerm={setSearchFilterTerm}
				searchFilterTerm={searchFilterTerm}
				type="stocklists"/>
		</Box>
	);
}
